import * as SplashScreen from "expo-splash-screen";
import { useEffect, useState } from "react";
import * as Font from "expo-font";
import { Platform } from "react-native";

export default function useCachedResources() {
  const [isLoadingComplete, setLoadingComplete] = useState(false);

  // Load any resources or data that we need prior to rendering the app
  useEffect(() => {
    async function loadResourcesAndDataAsync() {
      try {
        SplashScreen.preventAutoHideAsync();
        if (Platform.OS === "web") {
          await Font.loadAsync({
            "roboto-bold": require("assets/fonts/Roboto-Bold.ttf"),
            "roboto-regular": require("assets/fonts/Roboto-Regular.ttf"),
            "roboto-light": require("assets/fonts/Roboto-Light.ttf"),
            "roboto-medium": require("assets/fonts/Roboto-Medium.ttf"),
          });
        }
      } catch (e) {
        // We might want to provide this error information to an error reporting service
        console.warn(e);
      } finally {
        setLoadingComplete(true);
        SplashScreen.hideAsync();
      }
    }

    loadResourcesAndDataAsync();
  }, []);

  return isLoadingComplete;
}
